@if (this.loading) {
  <div class="text-center py-5">
    <span i18n="@@loading-german">Wird geladen…</span>
  </div>
} @else if (this.groups.length === 0) {
  <h3 class="with-manual-link">
    <span i18n="@@user-docs">Nutzer-Dokumente</span>
  </h3>
  <p-message severity="info">
    <span i18n="@@user-docs-empty">Noch keine Nutzer-Dokumente vorhanden. Nutzer können Dokumente im Chat hochladen,
        wenn das Feature aktiviert ist. Es kann <a [routerLink]="['../chatbot']">hier</a> aktiviert werden.</span>
    </p-message>
  } @else {
    <p-table
      dataKey="doc._id"
      [(selection)]="selectedDocuments"
      [value]="this.flatDocs"
      [rowHover]="true"
      styleClass="p-datatable-sm"
      >
      <ng-template pTemplate="header">
        <tr>
          <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
          <th style="width: 72px"></th>
          <th i18n="@@user-name">Nutzer</th>
          <th i18n="@@filename">Dateiname</th>
          <th i18n="@@uploaded-short">Hochgeladen</th>
          <th i18n="@@actions">Aktionen</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-item
        >
        <tr class="align-middle">
          <td class="bot-selection-cell"><p-tableCheckbox [value]="item" [ariaLabel]="item.doc.filename" /></td>
          <td>
            <i class="ri-file-text-line text-muted"></i>
          </td>
          <td>{{ item.userName }}</td>
          <td>
            {{ item.doc.filename }}
          </td>
          <td class="text-nowrap">{{ item.doc.uploadDate | date:'dd.MM.yyyy' }}</td>
          <td
            style="width: 2rem;"
            class="text-end"
            >
            <p-menu
              #menu
              appendTo="body"
              [model]="docContextMenu"
              [popup]="true"
            ></p-menu>
            <p-button
              (onClick)="openDocMenu($event, menu, item.doc)"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              [raised]="true"
              icon="ri ri-more-2-fill"
            ></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <app-bulk-action-bar [actions]="bulkActions" [count]="selectedDocuments.length" [allSelected]="allSelected"
      (selectAll)="toggleAll(true)" (clear)="selectedDocuments = []" />
  }

  <p-confirmDialog></p-confirmDialog>
